class GeoRedirect {
  constructor() {
    this.geoRedirectCookie = this.getCookie("geo-redirect-popup-shown")
    this.geoCodeCookie = this.getCookie("nitro_geot_country_code")

    if (!this.geoRedirectCookie && this.geoCodeCookie) {
      this.modalInit()
    }
  }

  modalInit() {
    this.currentPage = this.getCurrentPage()
    this.targetPage = this.getTargetPage()

    if (this.currentPage === this.targetPage.name) return

    this.injectModalHTML()
    this.el = document.querySelector(".geo-redirect")
    this.buttons = this.el.querySelectorAll("a")

    this.events()
    document.cookie = "geo-redirect-popup-shown=true;path=/"
  }

  injectModalHTML() {
    let html = `
		<div class="geo-redirect">
			<div class="geo-redirect__inner">
				<h3 class="geo-redirect__heading splitit-heading">You\'re viewing our ${this.currentPage} site.</h3>
        <p class="geo-redirect__text splitit-paragraph">For the most relevant information and local support, visit our ${this.targetPage.name} site.</p>
				<div class="geo-redirect__buttons">
					<a href="${SiteVars.homeURL}/${this.targetPage.slug}" data-redirect="true" class="splitit-button splitit-button--primary">Go to ${this.targetPage.name} site</a>
					<a href="#" data-redirect="false" class="splitit-button splitit-button--primary-outline">Stay on ${this.currentPage} site</a>
				</div>
			</div>
		</div>`

    document.querySelector("body").insertAdjacentHTML("beforeend", html)
  }

  events() {
    this.buttons.forEach((button) => {
      button.addEventListener("click", (e) => this.handleButtonClick(e))
    })
  }

  closeModal(e) {
    e.preventDefault()
    this.el.classList.add("geo-redirect--closing")
    setTimeout(() => {
      this.el.remove()
    }, 250)
  }

  handleButtonClick(e) {
    // e.preventDefault()

    if (e.target.dataset.redirect == "true") {
      document.cookie = "geo-redirected=true;path=/"
    } else {
      document.cookie = "geo-redirected=false;path=/"
      this.closeModal(e)
    }
  }

  getCurrentPage() {
    switch (window.location.pathname) {
      case "/" || "/us/":
        return "US"
      case "/jp/":
        return "Japan"
      default:
        return "global"
    }
  }

  getTargetPage() {
    switch (this.geoCodeCookie) {
      case "us":
        return {
          name: "US",
          slug: "us",
        }
      case "jp":
        return {
          name: "Japan",
          slug: "jp",
        }
      default:
        return {
          name: "global",
          slug: "global",
        }
    }
  }

  getCookie(name) {
    return document.cookie.match(new RegExp(`${name}=([^;]+)`))?.[1] ?? null
  }
}

new GeoRedirect()
